import apiClient from "./middleware";
import {
  SoundRecordingParentData,
  ChannelManagerList,
  SoundRecordingAudit,
  StubAssetsAudit,
  IncorrectAssetTypesAudit,
  MusicVideoMetadataMismatchAudit,
  ChannelSettingsWithId,
  MusicAuditStats,
} from "../utils/@types";
import { MusicVideoToUpdateWithSoundRecoridngMetaDataObjectType } from "../utils/Types/@CloudFunctionsTypes";
import { WhitelistRule } from "../Interfaces/interfaces";
import { dsrAuditsApi } from "./dsrAuditsApi";
import { metadataSpellcheckApi } from "./metadataSpellcheckApi";
import { bannerDashboardApi } from "./bannerDashboardApi";
import { bannerSwapApi } from "./bannerSwapApi";
import { assetScraperExplorerApi } from "./assetScraperExplorerApi";
import { assetScraperExportApi } from "./assetScraperExportApi";
import { metadataAuditComparerApi } from "./metadataAuditComparerApi";
import { oacPlaylistApi } from "./oacPlaylistApi";


const musicControlSuitService = {
  putPushMVMetaDataTasks: async (
    data: MusicVideoToUpdateWithSoundRecoridngMetaDataObjectType[]
  ) => {
    const response = await apiClient.put(
      "/MusicControlSuit/PushSoundRecordingsMetadataToMusicVideo",
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  },
};

const generalService = {
  connect: async () => {
    try {
      const response = await apiClient.get(`/`);
      if (response.status === 200) {
        return true;
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};

const musicAssetAuditService = {
  getMissingSoundRecordings: async (
    filters: any
  ): Promise<SoundRecordingAudit[]> => {
    try {
      const response = await apiClient.get(
        `/MusicControlSuit/MissingSoundRecordings`,
        { params: filters }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  getMismatchedSoundRecordings: async (
    filters: any
  ): Promise<SoundRecordingAudit[]> => {
    try {
      const response = await apiClient.get(
        `/MusicControlSuit/MismatchedSoundRecordings`,
        { params: filters }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  getIncorrectAssetTypes: async (
    filters: any
  ): Promise<IncorrectAssetTypesAudit[]> => {
    try {
      const response = await apiClient.get(
        `/MusicControlSuit/IncorrectAssetTypes`,
        { params: filters }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  getMusicAuditStats: async (filters: any): Promise<MusicAuditStats> => {
    try {
      const response = await apiClient.get(`/MusicControlSuit/MusicAuditStats`, {
        params: filters,
      });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  getMusicAuditStatsFilters: async (filters?: {
    legalEntityType?: string;
  }): Promise<{
    legalEntityTypes: string[];
    legalEntities: string[];
    channelIds: string[];
    channelManagerNames: string[];
  }> => {
    try {
      const response = await apiClient.get(
        `/MusicControlSuit/MusicAuditStats/filters`,
        { params: filters }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  getMusicVideoMetadataMismatches: async (
    filters: any
  ): Promise<MusicVideoMetadataMismatchAudit[]> => {
    try {
      const response = await apiClient.get(
        `/MusicControlSuit/MusicVideoMetadataMismatches`,
        { params: filters }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  updateIncorrectAssetTypes: async (data: {
    videoId: string;
    checked?: boolean;
    notes?: string;
  }) => {
    try {
      const response = await apiClient.post(
        `/MusicControlSuit/UpdateIncorrectAssetTypes`,
        data
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  updateMusicVideoMetadataMismatch: async (data: {
    musicVideoAssetId: string;
    checked?: boolean;
    notes?: string;
  }) => {
    try {
      const response = await apiClient.post(
        `/MusicControlSuit/UpdateMusicVideoMetadataMismatch`,
        data
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  pushIncorrectAssetTypesUpdateTask: async (
    data: {
      assetId: string;
      assetType: string;
      contentOwner: string;
    }[]
  ) => {
    try {
      const response = await apiClient.post(
        `/MusicControlSuit/IncorrectAssetTypes/update`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  updateMissingSoundRecording: async (data: {
    videoId: string;
    checked?: boolean;
    notes?: string;
  }) => {
    try {
      const response = await apiClient.post(
        `/MusicControlSuit/UpdateMissingSoundRecording`,
        data
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  getNoSoundRecording: async () => {
    try {
      const response = await apiClient.get(`/MusicAssetAudit/NoSoundRecording`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  getIncorrectOwnershipSync: async () => {
    try {
      const response = await apiClient.get(
        `/MusicAssetAudit/IncorrectOwnershipSync`
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};

const dbService = {
  getHealthStatistics: async () => {
    try {
      const response = await apiClient.get(`/db/healthMetrics`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  updateStatCardsClaimsAds: async (): Promise<any> => {
    try {
      const response = await apiClient.get(
        `/db/youtube-scorecard-stats/claims-ads`
      );

      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error updating statCards for Scorecard:", error);
      throw error;
    }
  },
  updateStatCardsMetadata: async (): Promise<any> => {
    try {
      const response = await apiClient.get(
        `/db/youtube-scorecard-stats/metadata`
      );

      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error updating statCards for Scorecard:", error);
      throw error;
    }
  },
};

const usersService = {
  updateUserRole: async (userEmail: string, role: string, active: string) => {
    try {
      const response = await apiClient.put(`/users/role`, null, {
        params: {
          email: userEmail,
          role: role,
          active: active,
        },
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  updateUserTools: async (userEmail: string, tools: string[]) => {
    try {
      const response = await apiClient.put(
        `/users/tools`,
        {},
        {
          params: {
            email: userEmail,
            tools: JSON.stringify(tools),
          },
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  initializeClaims: async (userEmail: string) => {
    try {
      const response = await apiClient.post(`/users/initialize-claims`, {
        email: userEmail,
      });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  getAllUsers: async (activeFilter?: "active" | "inactive" | "all") => {
    try {
      const params =
        activeFilter === "active"
          ? { active: "true" }
          : activeFilter === "inactive"
            ? { active: "false" }
            : undefined;
      const response = await apiClient.get(`/users/all`, { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  getValidTools: async () => {
    try {
      const response = await apiClient.get<{ tools: { value: string; label: string }[] }>(
        `/users/valid-tools`
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  syncAllUsersClaims: async () => {
    try {
      const response = await apiClient.post<{ message: string }>(
        `/users/sync-claims`,
        {}
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};

const bannerSwapService = bannerSwapApi;


const mbmService = {
  linkMusicVideoAsset: async (
    linkingRows: { musicVideoId: string; soundRecordingId: string }[]
  ): Promise<any> => {
    try {
      const response = await apiClient.post(
        `/MBM/linkMusicVideoAsset`,
        linkingRows
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  addVideoIdWhitelist: async (videoId: string): Promise<any> => {
    try {
      const response = await apiClient.post(`/MBM/addVideoIdWhitelist`, {
        videoId,
      });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  getVideoIdWhitelist: async (): Promise<any> => {
    try {
      const response = await apiClient.get(`/MBM/getVideoIdWhitelist`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};


const youtubeScorecardService = {
  updateYouTubeScorecardMetadata: async (): Promise<any> => {
    try {
      const response = await apiClient.get(`/youtube-scorecard/copy-metadata`);

      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching YouTubeScorecard data:", error);
      throw error;
    }
  },
  updateYouTubeScorecardClaimsAds: async (): Promise<any> => {
    try {
      const response = await apiClient.get(
        `/youtube-scorecard/copy-claims-ads`
      );

      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching YouTubeScorecard data:", error);
      throw error;
    }
  },
  getYouTubeScorecardMetadata: async (): Promise<any> => {
    try {
      const response = await apiClient.get(`/youtube-scorecard/fetch-metadata`);

      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching YouTubeScorecard data:", error);
      throw error;
    }
  },
  getYouTubeScorecardClaimsAds: async (): Promise<any> => {
    try {
      const response = await apiClient.get(
        `/youtube-scorecard/fetch-claims-ads`
      );

      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching YouTubeScorecard data:", error);
      throw error;
    }
  },
  getYouTubeScorecardClaimsAdsClaimDetails: async (
    videoId: string
  ): Promise<{
    videoId: string;
    videoTitle?: string;
    thirdPartyClaims: string | null;
    syncThirdPartyClaims: string | null;
  }> => {
    const response = await apiClient.get(
      `/youtube-scorecard/fetch-claims-ads-details/${encodeURIComponent(videoId)}`
    );
    return response.data;
  },
  getYouTubeScorecardClaimsAdsClaimDetailsBulk: async (
    videoIds: string[]
  ): Promise<{
    detailsByVideoId: Record<
      string,
      {
        videoId: string;
        videoTitle?: string;
        thirdPartyClaims: string | null;
        syncThirdPartyClaims: string | null;
      }
    >;
  }> => {
    const response = await apiClient.post(
      `/youtube-scorecard/fetch-claims-ads-details`,
      { videoIds }
    );
    return response.data;
  },
  resolveAssetTitles: async (
    assetIds: string[],
    videoIds: string[] = []
  ): Promise<{
    titlesByAssetId: Record<string, string>;
    titlesByVideoId: Record<string, string>;
  }> => {
    const response = await apiClient.post(
      `/youtube-scorecard/resolve-asset-titles`,
      { assetIds, videoIds }
    );
    return response.data;
  },
  getYouTubeScorecardWhitelist: async (): Promise<any> => {
    try {
      const response = await apiClient.get(
        `/youtube-scorecard/fetch-whitelist-rules`
      );
      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching YouTubeScorecard data:", error);
      throw error;
    }
  },
  fetchYoutubeScorecardMetadataStats: async (): Promise<any> => {
    try {
      const response = await apiClient.get(
        `/youtube-scorecard/fetch-metadata-stats`
      );
      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching YouTubeScorecard Stats data:", error);
      throw error;
    }
  },

  fetchYoutubeScorecardClaimsAdsStats: async (): Promise<any> => {
    try {
      const response = await apiClient.get(
        `/youtube-scorecard/fetch-claims-ads-stats`
      );
      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching YouTubeScorecard Stats data:", error);
      throw error;
    }
  },
  getYouTubeScorecardMetadataWhitelist: async (): Promise<any> => {
    try {
      const response = await apiClient.get(
        `/youtube-scorecard/fetch-metadata-whitelist`
      );
      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching YouTubeScorecard data:", error);
      throw error;
    }
  },
  getYouTubeScorecardClaimsAdsWhitelist: async (): Promise<any> => {
    try {
      const response = await apiClient.get(
        `/youtube-scorecard/fetch-claimsAds-whitelist`
      );

      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching YouTubeScorecard data:", error);
      throw error;
    }
  },
  createWhitelist: async (): Promise<any> => {
    try {
      const response = await apiClient.get(
        `/youtube-scorecard/create-whitelist`
      );

      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error updating statCards for Scorecard:", error);
      throw error;
    }
  },

  updateWhitelistRule: async (whitelistRule: WhitelistRule): Promise<any> => {
    try {
      console.log(
        "Sending POST request to /youtube-scorecard/update-whitelist with data:",
        whitelistRule
      ); // Log the data
      const response = await apiClient.post(
        `/youtube-scorecard/update-whitelist`,
        whitelistRule
      );
      return response.data;
    } catch (error) {
      console.error("Error updating whitelist rule:", error);
      throw error;
    }
  },

  addWhitelistRule: async (whitelistRule: WhitelistRule): Promise<any> => {
    try {
      console.log(
        "Sending POST request to /youtube-scorecard/add-whitelist-rule with data:",
        whitelistRule
      ); // Log the data
      const response = await apiClient.post(
        `/youtube-scorecard/add-whitelist-rule`,
        whitelistRule
      );
      return response.data;
    } catch (error) {
      console.error("Error updating whitelist rule:", error);
      throw error;
    }
  },

  removeWhitelistRule: async (whitelistRule: WhitelistRule): Promise<any> => {
    try {
      console.log(
        "Sending POST request to /youtube-scorecard/remove-whitelist-rule",
        whitelistRule
      );
      const response = await apiClient.post(
        `/youtube-scorecard/remove-whitelist-rule`,
        whitelistRule
      );
      return response.data;
    } catch (error) {
      console.error("Error removing whitelist rule:", error);
      throw error;
    }
  },
  rerunWhitelistRules: async (): Promise<any> => {
    try {
      console.log(
        "Sending POST request to /youtube-scorecard/reapply-whitelist-rule"
      );
      const response = await apiClient.post(
        `/youtube-scorecard/reapply-whitelist-rule`
      );
      return response.data;
    } catch (error) {
      console.error("Error removing whitelist rule:", error);
      throw error;
    }
  },
  videoReportCheck: async (): Promise<any> => {
    try {
      const response = await apiClient.get(
        `/youtube-scorecard/videoReportCheck`
      );
      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching YouTubeScorecard data:", error);
      throw error;
    }
  },
  getChannelMangerListFromBQ: async (): Promise<ChannelManagerList> => {
    try {
      const response = await apiClient.get(
        `/youtube-scorecard/getChannelMangerList`
      );
      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching YouTubeScorecard data:", error);
      throw error;
    }
  },
  updateChannelManagerListInFirestore: async (): Promise<
    ChannelManagerList[]
  > => {
    try {
      const response = await apiClient.get(
        `/youtube-scorecard/fetch-channel-manager-list`
      );
      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching YouTubeScorecard data:", error);
      throw error;
    }
  },
  dailyTrackinClaimsAds: async (): Promise<any[]> => {
    try {
      const response = await apiClient.get(
        `/youtube-scorecard/daily-statistics-tracking-claims-ads`
      );
      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching YouTubeScorecard data:", error);
      throw error;
    }
  },
  dailyTrackinMetadata: async (): Promise<any[]> => {
    try {
      const response = await apiClient.get(
        `/youtube-scorecard/daily-statistics-tracking-metadata`
      );
      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching YouTubeScorecard data:", error);
      throw error;
    }
  },
};

const ytService = {
  getSoundRecording: async (
    customId: string
  ): Promise<SoundRecordingParentData> => {
    try {
      const response = await apiClient.get(`/YT/SoundRecording`, {
        params: {
          customId: customId,
        },
      });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  getLinkingIssues: async (): Promise<any> => {
    try {
      const response = await apiClient.get(`/YT/LinkingIssues`);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};

const spotifyPodcastUploaderService = {
  uploadSpotifyPodcast: async (
    uploadRows: {
      title: string;
      author: string;
      summary: string;
      seasonNumber: number;
      episodeNumber: number;
      status: string;
      draft: string;
      backgroundAudioFileUrl: string;
      podcast: string;
    }[]
  ): Promise<any> => {
    try {
      const response = await apiClient.post(
        `/spotifyPodcastUploader/upload`,
        uploadRows
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};

const stubAssetsAuditService = {
  getStubAssetsWithSRLink: async (filters: any): Promise<StubAssetsAudit[]> => {
    try {
      const response = await apiClient.get(
        `/MusicControlSuit/StubAssetsWithSRLink`,
        { params: filters }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  updateStubAssetsWithSRLink: async (data: {
    asset_id: string;
    checked?: boolean;
    notes?: string;
  }) => {
    try {
      const response = await apiClient.post(
        `/MusicControlSuit/UpdateStubAssetsWithSRLink`,
        data
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  syncStubAssetsWithSRLink: async () => {
    try {
      const response = await apiClient.post(
        `/MusicControlSuit/SyncStubAssetsWithSRLink`
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  recalculateStubAssetsPriorities: async () => {
    try {
      const response = await apiClient.post(
        `/MusicControlSuit/RecalculateStubAssetsPriorities`
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};

const scrapersService = {
  startMusicAssetScrape: async (data: {
    title: string;
    brand: string;
    tableName: string;
    assetIds: string[];
  }): Promise<{
    jobId: string;
    status: string;
    bigQueryTableName: string[];
    message: string;
  }> => {
    try {
      const response = await apiClient.post(
        `/scrapers/music-asset-scraper/start`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  getScrapeJobs: async (): Promise<
    {
      id: string;
      title: string;
      brand: string;
      tableName?: string;
      assetCount: number;
      status: "queued" | "running" | "completed" | "failed";
      createdAt: string;
      createdBy?: string;
      completedAt?: string;
      excelDownloadUrl?: string;
      bigQueryTableName?: string[];
      isDeleted?: boolean;
      deletedAt?: string;
      deletedBy?: string;
    }[]
  > => {
    try {
      const response = await apiClient.get(
        `/scrapers/music-asset-scraper/jobs`
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  getScrapeJobDeletionHistory: async (): Promise<
    {
      id: string;
      title: string;
      brand: string;
      tableName?: string;
      assetCount: number;
      status: "queued" | "running" | "completed" | "failed";
      createdAt: string;
      createdBy?: string;
      deletedAt?: string;
      deletedBy?: string;
    }[]
  > => {
    try {
      const response = await apiClient.get(
        `/scrapers/music-asset-scraper/jobs/deletion-history`
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  getScrapeJobStatus: async (
    jobId: string
  ): Promise<{
    id: string;
    status: "queued" | "running" | "completed" | "failed";
    progress?: number;
    completedAt?: string;
    excelDownloadUrl?: string;
    bigQueryTableName?: string[];
    errorMessage?: string;
  }> => {
    try {
      const response = await apiClient.get(
        `/scrapers/music-asset-scraper/jobs/${jobId}/status`
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  downloadScrapeResults: async (
    jobId: string
  ): Promise<{ blob: Blob; filename: string }> => {
    const response = await apiClient.get(
      `/scrapers/music-asset-scraper/jobs/${jobId}/download`,
      { responseType: "blob" }
    );
    const cd =
      (response.headers["content-disposition"] as string | undefined) ||
      (response.headers["Content-Disposition"] as string | undefined);
    let filename = `scrape_results_${jobId}.csv`;
    if (cd) {
      const quoted = cd.match(/filename="([^"]+)"/i);
      if (quoted?.[1]) {
        filename = quoted[1];
      } else {
        const star = cd.match(/filename\*=UTF-8''([^;\s]+)/i);
        if (star?.[1]) {
          filename = decodeURIComponent(star[1]);
        }
      }
    }
    return { blob: response.data as Blob, filename };
  },

  cancelScrapeJob: async (
    jobId: string
  ): Promise<{
    success: boolean;
    message: string;
  }> => {
    try {
      const response = await apiClient.post(
        `/scrapers/music-asset-scraper/jobs/${jobId}/cancel`
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  repullScrapeJob: async (
    jobId: string
  ): Promise<{
    jobId: string;
    status: string;
    message: string;
    bigQueryTableName?: string[];
  }> => {
    try {
      const response = await apiClient.post(
        `/scrapers/music-asset-scraper/jobs/${jobId}/repull`
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  deleteScrapeJob: async (
    jobId: string
  ): Promise<{
    success: boolean;
    message: string;
    jobId: string;
    deletedAt: string;
    deletedBy: string;
  }> => {
    try {
      const response = await apiClient.delete(
        `/scrapers/music-asset-scraper/jobs/${jobId}`
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  reconcileScrapeJobStatus: async (
    jobIds?: string[]
  ): Promise<{
    success: boolean;
    message: string;
    scanned: number;
    updated: number;
    deleted: number;
    skipped: number;
    results: Array<{
      jobId: string;
      previousStatus: "queued" | "running" | "completed" | "failed";
      nextStatus: "queued" | "running" | "completed" | "failed";
      updated: boolean;
      deleted?: boolean;
      reason: string;
      expectedAssetCount: number;
      foundAssetCount: number;
      missingAssetIds: string[];
    }>;
  }> => {
    try {
      const response = await apiClient.post(
        `/scrapers/music-asset-scraper/jobs/reconcile-status`,
        jobIds?.length ? { jobIds } : {},
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  validateAssetIds: async (
    assetIds: string[]
  ): Promise<{
    validIds: string[];
    invalidIds: string[];
    duplicates: string[];
  }> => {
    try {
      const response = await apiClient.post(
        `/scrapers/music-asset-scraper/validate-asset-ids`,
        { assetIds },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  explorer: assetScraperExplorerApi,
  export: assetScraperExportApi,
};

const proxyService = {
  proxyImage: async (url: string) => {
    try {
      const response = await apiClient.get(`/proxy/image`, {
        params: { url },
      });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};

const channelSettingsService = {
  getAllChannelSettings: async (): Promise<ChannelSettingsWithId[]> => {
    try {
      const response = await apiClient.get<{ data: ChannelSettingsWithId[] }>(
        `/channel-settings`
      );
      return response.data.data; // Controller returns { data: channelSettingsData }
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  getChannelSettingsIds: async (): Promise<string[]> => {
    try {
      const response = await apiClient.get<{ data: string[] }>(
        `/channel-settings/ids`
      );
      return response.data.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  getDefaultBanner: async (channelId: string): Promise<any> => {
    try {
      const response = await apiClient.get(`/channel-settings/default-banner`, {
        params: { channelId },
      });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  updateDefaultBanner: async (
    channelId: string,
    bannerURL: string,
    defaultBannerStoragePath?: string
  ): Promise<any> => {
    try {
      const response = await apiClient.put(`/channel-settings/default-banner`, {
        channelId,
        bannerURL,
        ...(defaultBannerStoragePath?.trim()
          ? { defaultBannerStoragePath: defaultBannerStoragePath.trim() }
          : {}),
      });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  getBannerAuditLogs: async (params: {
    channelId?: string;
    swapUID?: string;
    limit?: number;
  }): Promise<any> => {
    try {
      const response = await apiClient.get(`/banner-audit-log`, { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  acceptCurrentBannerAsDefault: async (channelId: string): Promise<any> => {
    try {
      const response = await apiClient.post(
        `/channel-settings/accept-current-as-default`,
        { channelId }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};

const oacAuditChannelIdsService = {
  getChannelIds: async (): Promise<string[]> => {
    try {
      const response = await apiClient.get<{ data: string[] }>(
        "/oac-audit/channel-ids"
      );
      return response.data.data ?? [];
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  addChannelId: async (channelId: string): Promise<string[]> => {
    try {
      const response = await apiClient.post<{ data: string[] }>(
        "/oac-audit/channel-ids",
        { channelId }
      );
      return response.data.data ?? [];
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  removeChannelId: async (channelId: string): Promise<string[]> => {
    try {
      const response = await apiClient.delete<{ data: string[] }>(
        `/oac-audit/channel-ids/${encodeURIComponent(channelId)}`
      );
      return response.data.data ?? [];
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  getChannelLastUpdates: async (): Promise<{
    data: Array<{
      channelId: string;
      channelDisplayName: string;
      lastPublishedAt: string | null;
      lastUploadAt: string | null;
      lastScheduledAtAny: string | null;
      lastScheduledThisMonth: string | null;
    }>;
    updatedAt: string | null;
  }> => {
    try {
      const response = await apiClient.get<{
        data: Array<{
          channelId: string;
          channelDisplayName: string;
          lastPublishedAt: string | null;
          lastUploadAt: string | null;
          lastScheduledAtAny: string | null;
          lastScheduledThisMonth: string | null;
        }>;
        updatedAt: string | null;
      }>("/oac-audit/channel-last-updates");
      return {
        data: response.data.data ?? [],
        updatedAt: response.data.updatedAt ?? null,
      };
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};

export interface CustomIdLookupResult {
  videoId: string;
  assetId: string;
  contentType: string;
  claimStatus: string;
  assetType: string;
  assetTitle: string;
  customId: string;
  cmsUsed: string;
}

export interface CustomIdLookupResponse {
  results: CustomIdLookupResult[];
  summary: {
    videosProcessed: number;
    totalClaims: number;
    uniqueCustomIds: number;
  };
}

export interface ContentOwner {
  id: string;
  displayName: string;
}

const youtubeCustomIdLookupService = {
  lookupCustomIds: async (
    videoIds: string[],
    claimsCmsId?: string,
    assetsCmsId?: string
  ): Promise<CustomIdLookupResponse> => {
    try {
      const response = await apiClient.post<CustomIdLookupResponse>(
        "/youtube-scorecard/custom-id-lookup",
        { videoIds, claimsCmsId, assetsCmsId }
      );
      return response.data;
    } catch (error) {
      console.error("Error looking up custom IDs:", error);
      throw error;
    }
  },

  listContentOwners: async (): Promise<ContentOwner[]> => {
    try {
      const response = await apiClient.get<{ contentOwners: ContentOwner[] }>(
        "/youtube-scorecard/content-owners"
      );
      return response.data.contentOwners ?? [];
    } catch (error) {
      console.error("Error listing content owners:", error);
      throw error;
    }
  },
};

export interface ReferenceStatusResult {
  referenceId: string;
  cmsId: string;
  httpStatus: number | null;
  status: string;
  statusReason: string;
  duplicateLeader: string;
  assetId: string;
  contentType: string;
  length: number | null;
  videoId: string;
  claimId: string;
  originationSource: string;
  excludedIntervalsCount: number;
  /** Asset-level daily engaged views from the latest CMS asset report in BigQuery. */
  dailyEngagedViews: number | null;
  viewsDataDate: string;
  /** Active claims made by this reference, from the latest CMS active-claims report in BigQuery. */
  claimedVideos: number | null;
  assetTitle: string;
  error: string;
}

export interface ReferenceStatusLookupResponse {
  results: ReferenceStatusResult[];
  viewsWarning?: string;
}

/** Must match MAX_REFERENCE_IDS_PER_REQUEST on the server. */
export const REFERENCE_STATUS_BATCH_SIZE = 200;

const youtubeReferenceStatusService = {
  lookupReferenceStatus: async (
    referenceIds: string[],
    cmsId: string
  ): Promise<ReferenceStatusLookupResponse> => {
    try {
      const response = await apiClient.post<ReferenceStatusLookupResponse>(
        "/youtube-scorecard/reference-status-lookup",
        { referenceIds, cmsId }
      );
      return { results: response.data.results ?? [], viewsWarning: response.data.viewsWarning };
    } catch (error) {
      console.error("Error looking up reference status:", error);
      throw error;
    }
  },
};

const apiService = {
  musicControlSuit: musicControlSuitService,
  general: generalService,
  musicAssetAudit: musicAssetAuditService,
  stubAssetsAudit: stubAssetsAuditService,
  scrapers: scrapersService,
  db: dbService,
  users: usersService,
  bannerSwap: bannerSwapService,
  bannerDashboard: bannerDashboardApi,
  mbm: mbmService,
  youtubeScorecard: youtubeScorecardService,
  yt: ytService,
  spotifyPodcastUploader: spotifyPodcastUploaderService,
  dsrAudits: dsrAuditsApi,
  proxy: proxyService,
  channelSettings: channelSettingsService,
  oacAuditChannelIds: oacAuditChannelIdsService,
  oacPlaylists: oacPlaylistApi,
  youtubeCustomIdLookup: youtubeCustomIdLookupService,
  youtubeReferenceStatus: youtubeReferenceStatusService,
  metadataSpellcheck: metadataSpellcheckApi,
  metadataAuditComparer: metadataAuditComparerApi,
};

export { apiService, bannerDashboardApi, bannerSwapApi };
